import { Component, createRef, HTMLAttributes } from 'react'
import * as debounce from 'lodash/debounce'

type InfiniteWindowScrollProps = HTMLAttributes<HTMLDivElement> & {
  hasMore: boolean
  isLoading: boolean
  // when to load, px
  threshold: number
  onLoadMore: () => void
}

export class InfiniteWindowScroll extends Component<InfiniteWindowScrollProps> {

  private nodeRef = createRef<HTMLDivElement>()

  render () {
    const {
      hasMore,
      isLoading,
      threshold,
      onLoadMore,
      children,
      ...htmlProps
    } = this.props

    return (
      <div { ...htmlProps } ref={ this.nodeRef }>{ children }</div>
    )
  }

  componentDidMount () {
    this.loadIfScrolledDebounced()
    window.addEventListener('scroll', this.loadIfScrolled)
  }

  componentDidUpdate () {
    this.loadIfScrolledDebounced()
  }

  componentWillUnmount () {
    this.loadIfScrolledDebounced.cancel()
    window.removeEventListener('scroll', this.loadIfScrolled)
  }

  private loadIfScrolled = () => {
    const {
      hasMore,
      isLoading,
      threshold,
      onLoadMore,
    } = this.props

    if (!hasMore || isLoading || !this.nodeRef.current) {
      return
    }

    // take rect instead of pageYOffset to avoid bug with <PreventScroll />
    const nodeRect = this.nodeRef.current.getBoundingClientRect()
    if (nodeRect.bottom <= threshold) {
      onLoadMore()
    }
  }

  // this method should be debounced since
  // document.body.scrollHeight may be from prev page when component mounts
  private loadIfScrolledDebounced = debounce(this.loadIfScrolled, 15)
}
